import * as React from "react"

// @ts-ignore
import SaIconMan from "../../../images/svg/sa-icon-man.svg"
// @ts-ignore
import SaIconDiamond from "../../../images/svg/sa-icon-diamond.svg"
// @ts-ignore
import SaIconHeart from "../../../images/svg/sa-icon-heart.svg"
// @ts-ignore
import SaIconShare from "../../../images/svg/sa-icon-share.svg"
// @ts-ignore
import SaIconPeople from "../../../images/svg/sa-icon-people.svg"
// @ts-ignore
import SaIconPeople2 from "../../../images/svg/sa-icon-people-2.svg"
// @ts-ignore
import SaIconFaq from "../../../images/svg/sa-icon-faq.svg"
// @ts-ignore
import SaIconLamp from "../../../images/svg/sa-icon-lamp.svg"
// @ts-ignore
import SaIconClock from "../../../images/svg/sa-icon-clock.svg"
// @ts-ignore
import SaIconClockYellow from "../../../images/svg/sa-icon-clock-yellow.svg"
// @ts-ignore
import SaIconLetter from "../../../images/svg/sa-icon-letter.svg"

// @ts-ignore
import SaIconAdvertising from "../../../images/svg/sa-icon-advertising.svg"
// @ts-ignore
import SaIconAnalytics from "../../../images/svg/sa-icon-analytics.svg"
// @ts-ignore
import SaIconCart from "../../../images/svg/sa-icon-cart.svg"
// @ts-ignore
import SaIconCRO from "../../../images/svg/sa-icon-cro.svg"
// @ts-ignore
import SaIconDemandGen from "../../../images/svg/sa-icon-demand-gen.svg"
// @ts-ignore
import SaIconEnvelope from "../../../images/svg/sa-icon-envelope.svg"
// @ts-ignore
import SaIconLikeGreen from "../../../images/svg/sa-icon-like-green.svg"
// @ts-ignore
import SaIconLikePurple from "../../../images/svg/sa-icon-like-purple.svg"
// @ts-ignore
import SaIconLikeRed from "../../../images/svg/sa-icon-like-red.svg"
// @ts-ignore
import SaIconPlanning from "../../../images/svg/sa-icon-planning.svg"
// @ts-ignore
import SaIconTrend from "../../../images/svg/sa-icon-trend.svg"
// @ts-ignore
import SaIconTrend2 from "../../../images/svg/sa-icon-trend-2.svg"
// @ts-ignore
import SaIconConnect from "../../../images/svg/sa-icon-connectivity.svg"
// @ts-ignore
import SaIconConnectYellow from "../../../images/svg/sa-icon-connectivity-yellow.svg"
// @ts-ignore
import SaIconBrand from "../../../images/svg/sa-icon-brand.svg"
// @ts-ignore
import SaIconCollaborate from "../../../images/svg/sa-icon-collaboration.svg"
// @ts-ignore
import SaIconCollaborateBlue from "../../../images/svg/sa-icon-collaboration-blue.svg"
// @ts-ignore
import SaIconOpportunity from "../../../images/svg/sa-icon-opportunity.svg"



// @ts-ignore
import SaIconHonorBandMention from "../../../images/svg/sa-icon-honor-band-mention.svg"
// @ts-ignore
import SaIconMarketing from "../../../images/svg/sa-icon-marketing.svg"
// @ts-ignore
import SaIconRemarketing from "../../../images/svg/sa-icon-remarketing.svg"
// @ts-ignore
import SaIconUser from "../../../images/svg/sa-icon-user.svg"
// @ts-ignore
import SaIconWebsite from "../../../images/svg/sa-icon-website.svg"


// @ts-ignore
import SaIconFlag from "../../../images/svg/sa-icon-flag.svg"
// @ts-ignore
import SaIconLampPurple from "../../../images/svg/sa-icon-lamp-purple.svg"
// @ts-ignore
import SaIconCompany from "../../../images/svg/sa-icon-company.svg"
// @ts-ignore
import SaIconStartUp from "../../../images/svg/sa-icon-start-up.svg"
// @ts-ignore
import SaIconPeople3 from "../../../images/svg/sa-icon-people-3.svg"



const imgs = {
  'null': null,
  'man': SaIconMan,
  'diamond': SaIconDiamond,
  'heart': SaIconHeart,
  'share': SaIconShare,
  'people': SaIconPeople,
  'people2': SaIconPeople2,
  'people3': SaIconPeople3,
  'faq': SaIconFaq,
  'lamp': SaIconLamp,
  'lampPurple': SaIconLampPurple,
  'clock': SaIconClock,
  'clockYellow': SaIconClockYellow,
  'letter': SaIconLetter,
  'advertising': SaIconAdvertising,
  'analytics': SaIconAnalytics,
  'cart': SaIconCart,
  'cro': SaIconCRO,
  'demandGen': SaIconDemandGen,
  'envelope': SaIconEnvelope,
  'likeGreen': SaIconLikeGreen,
  'likePurple': SaIconLikePurple,
  'likeRed': SaIconLikeRed,
  'planning': SaIconPlanning,
  'trend': SaIconTrend,
  'trend2': SaIconTrend2,
  'connect': SaIconConnect,
  'connectYellow': SaIconConnectYellow,
  'brand': SaIconBrand,
  'collaborate': SaIconCollaborate,
  'collaborateBlue': SaIconCollaborateBlue,
  'opportunity': SaIconOpportunity,
  'honorBandMention': SaIconHonorBandMention,
  'marketing': SaIconMarketing,
  'remarketing': SaIconRemarketing,
  'user': SaIconUser,
  'website': SaIconWebsite,
  'company': SaIconCompany,
  'startUp': SaIconStartUp,
  'flag': SaIconFlag,
}


interface SaSwitchIcons {
  icon?: string
}


const SaSwitchIcons: React.FC<SaSwitchIcons> = (props) => {

  const [Image, setImage] = React.useState(null);

  React.useEffect(()=>{
    props.icon && setImage(imgs[props.icon]);
  },[props.icon]);



  return(
    <img src={Image} alt="" />
  )

}

export default SaSwitchIcons